import React from "react";
import "./FeaturedCard.css";
import {
  FaMapMarkerAlt,
  FaGlobe,
  FaBriefcase,
  FaBuilding,
  FaCheckCircle,
} from "react-icons/fa";

const FeaturedCard = ({ item, type, onViewBusiness }) => {
  const isBusiness = type === "business";
  const name = item.serviceName || item.userName || "Unnamed";
  const description =
    item.description || item.serviceDetails || "No description available";
  const slug = item.slug || "default-slug";
  const timeZone = item.timeZone || "Asia/Kolkata";
  const location = item.location || item.countryName || "Not specified";
  const serviceCategory = item.serviceCategory || "";
  const imageUrl = item.imageUrl || "";
  const imageBaseUrl = item.imageBaseUrl || "";
  const isOnline = item.onlineAvailable === "true";

  const handleClick = () => {
    if (isBusiness && onViewBusiness) onViewBusiness(item);
    else window.location.href = `${window.location.origin}/yuukke-service/${slug}`;
  };

  return (
    <div className="featured-card" onClick={handleClick}>
      {/* ---------- IMAGE SECTION ---------- */}
      <div className="featured-img-container">
        {imageUrl ? (
          <img
            src={`${imageBaseUrl}${imageUrl}`}
            alt={name}
            className="featured-img"
            onError={(e) => (e.currentTarget.style.display = "none")}
          />
        ) : (
          <div className="featured-fallback"></div>
        )}

        <div className="featured-overlay"></div>

        {/* ---------- VERIFIED BADGE (TOP-LEFT) ---------- */}
        <span className="featured-badge verified">
          <FaCheckCircle className="badge-icon" /> Verified
        </span>

        <div className="corner-accent"></div>
      </div>

      {/* ---------- CONTENT SECTION ---------- */}
      <div className="featured-content">
        <h3 className="featured-title">
          {name}
          <span className="underline"></span>
        </h3>

        <div className="featured-meta">
          {location && (
            <span className="featured-location">
              <FaMapMarkerAlt className="meta-icon" /> {location}
            </span>
          )}
          {timeZone && <span className="featured-timezone">⏰ {timeZone}</span>}
        </div>

        {serviceCategory && (
          <div className="featured-category">{serviceCategory}</div>
        )}

        <p className="featured-desc">{description}</p>

        <div className="featured-arrow">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
      </div>

      {/* ---------- BADGES BELOW CARD ---------- */}
      <div className="featured-badges-below">
        <span className={`featured-badge ${isBusiness ? "biz" : "srv"}`}>
          {isBusiness ? (
            <>
              <FaBuilding className="badge-icon" /> Business
            </>
          ) : (
            <>
              <FaBriefcase className="badge-icon" /> Service
            </>
          )}
        </span>

        {isOnline && (
          <span className="featured-badge online">
            <FaGlobe className="badge-icon" /> Online
          </span>
        )}
      </div>

      <div className="bottom-line"></div>
    </div>
  );
};

export default FeaturedCard;
